<template>
    <v-form v-model="valid">
        <!--v-row class="ma-1">
            <v-col cols="12" md="11" class="py-md-0 py-sm-1 d-flex flex-row align-start flex-grow-1 flex-shrink-0 order-xs-2 order-md-1">
            <NumericField dense outlined
                v-model="c_data.min_use"
                :rules="[rules.mandatory]"
                label="range di funzionamento: minimo"
                :readonly="preview"
                placeholder="0"
            ></NumericField>    
            <NumericField dense outlined
                class="pl-2"
                v-model="c_data.max_use"
                :rules="[rules.mandatory]"
                label="range di funzionamento: massimo"
                :readonly="preview"
                placeholder="0"
            ></NumericField>
            </v-col> 
        </v-row-->
    </v-form>
</template>
<script>
import {getModel} from "../utils/model"
import {f_rules} from '../utils/commonUtils'
export default {
    props: {
        'data':{
            type: Object,
            required: true
        }, 
        'preview': {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            valid: true,
            c_data: null,
            rules: f_rules
        }
    },
    watch: {
        'valid':{
            immediate: true,
            handler() {
                this.$parent.$emit('validitySpecific', this.valid)
            }
        }
    },
    beforeMount() {
        console.log("$$debug: data", this.data)
        if(this.data && this.data.block && this.data.block.model){
            if (_.isEmpty(this.data.p_data)){
                let Model = getModel(this.data.block.model)
                this.c_data = Model()
            } else {
                this.c_data = _.cloneDeep(this.data.p_data)
            }
        } else {
            console.log("debug: error", this.data)
        }
    },
    methods: {
        exportData(){
            console.log("$$ debug exporting data")
            if(this.c_data && this.c_data.values.length > 0 ){
                this.$parent.$emit('autoUpdate', this.c_data)
            }
        },
        getData() {
            return this.c_data
        }
        

    },
}
</script>